import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { BiTematica } from '../../models/bi-tematica.model';
import { BiTematicaService } from '../../services/bi-tematica.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-bi-tematica-edit',
  templateUrl: './bi-tematica-edit.component.html',
  styleUrls: ['./bi-tematica-edit.component.scss']
})
export class BiTematicaEditComponent extends BaseFormComponent<BiTematica> implements OnInit {

  actionLabel: string = 'Novo';

  constructor(
    private myService: BiTematicaService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.loaded();
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl('', [Validators.required]),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
    }
  }

  voltar() {
    this.navigation.back(['projetos/admin-spgg/bi-tematica']);
  }

  getDataCreate(): BiTematica {
    let data: BiTematica;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: BiTematica) => {
              this.msgSuccess('Cadastro alterado com sucesso!');
              this.loaded();
            },
            error: (error) => {
              this.loaded();
              this.msgError();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: BiTematica) => {
              this.msgSuccess('Cadastro criado com sucesso!');
              this.navigation.replace(['projetos/admin-spgg/bi-tematica/', res.id]);
              this.loaded();
            },
            error: (error) => {
              this.loaded();
              this.msgError();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }
}
